import { PropsWithChildren } from 'react';
import { HydrationBoundary, HydrationBoundaryProps } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
function ReactQueryHydrate({
  children,
  ...props
}: HydrationBoundaryProps & PropsWithChildren) {
  return <HydrationBoundary {...props} data-sentry-element="HydrationBoundary" data-sentry-component="ReactQueryHydrate" data-sentry-source-file="react-query-hydrate.tsx">
            {children}
            <div className='left-to-right absolute'>
                <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' data-sentry-element="ReactQueryDevtools" data-sentry-source-file="react-query-hydrate.tsx" />
            </div>
        </HydrationBoundary>;
}
export default ReactQueryHydrate;